import { BaseMaskAdapter } from "./base-adapter";

const ZIPCODE_MASK = "99999-999";

export class ZipcodePresetAdapter extends BaseMaskAdapter {
  constructor() {
    super(ZIPCODE_MASK);
  }
  formatForDisplay(value: unknown): string {
    if (this.isEmpty(value)) {
      return "";
    }
    return this.applyGenericMask(String(value));
  }

  parseFromInput(inputValue: string): { value: string; formatted: string } {
    if (inputValue === "" || this.cleanValue(inputValue) === "") {
      return { value: "", formatted: "" };
    }

    const formatted = this.applyGenericMask(inputValue);
    const cleanValue = this.cleanValue(formatted);

    return {
      value: cleanValue,
      formatted,
    };
  }

  handleControlledUpdate(value: unknown): string {
    if (this.isEmpty(value)) {
      return "";
    }
    return this.applyGenericMask(String(value));
  }

  isKeyAllowed(key: string): boolean {
    if (this.isControlKey(key)) {
      return true;
    }
    return /^\d$/.test(key);
  }
}
